<script setup lang="ts">
// TODO: Replace with OldBreadcrumbs from @/shared/components/ui/breadcrumbs.vue when available
// TODO: Replace with categoryURL from @/shared/plugins/business/main when available

import { MMLink, MMText } from '@mm-frontend/mm-web-ui-kit';
import { useProductPage } from '../../business/use-product-page';

// Get product page instance
const { categories } = useProductPage();

// Mock functions until proper components are available
const categoryURL = (crumb: any) => {
  console.log('TODO: Implement categoryURL function from @/shared/plugins/business/main');
  return `/category/${crumb.id}`;
};
</script>

<template>
  <div itemscope class="breadcrumbs-wrapper" itemtype="http://schema.org/BreadcrumbList">
    <div class="breadcrumb" :index="1">
      <MMLink to="/" itemprop="item">
        <MMText font="Body M/Regular" color="tertiary" itemprop="name">Главная </MMText>
      </MMLink>
    </div>

    <MMLink
      v-for="(crumb, index) in categories"
      :index="index + 2"
      :key="crumb.id"
      class="breadcrumb"
      itemprop="item"
      :to="categoryURL(crumb)"
    >
      <MMText font="Body M/Regular" color="tertiary" itemprop="name">
        /&nbsp;&nbsp;{{ crumb.title }}
      </MMText>
    </MMLink>
  </div>
</template>

<style lang="stylus" scoped>
.breadcrumbs-wrapper
  display flex
  flex-wrap wrap
  gap 8px
  padding 3px 0

.breadcrumb
  a
    text-decoration none

    &:hover
      text-decoration underline
</style>
